/**
 * Move keyboard focus to the main landmark when the control that held it is
 * about to disappear, so a keyboard or screen-reader user continues from the
 * page content instead of from the top of the document. The landmark is made
 * programmatically focusable only for that moment (the same pattern
 * KeptRecordingNotice uses for its own handoff).
 */
export function focusMainLandmark(): boolean {
  if (typeof document === 'undefined') return false;
  const main = document.getElementById('main-content') ?? document.querySelector<HTMLElement>('main');
  if (!main) return false;
  if (!main.hasAttribute('tabindex')) {
    main.setAttribute('tabindex', '-1');
    main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true });
  }
  main.focus({ preventScroll: true });
  return document.activeElement === main;
}
